import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';


export const LoadingPaySumSkeleton = (): JSX.Element => {
    return (
        <SkeletonTheme enableAnimation={true} borderRadius={24} inline={false}>
            <ListContainer $size={4} $direction={'column'} style={{ width: '100%' }}>
                <Skeleton height={24}/>
                <Skeleton height={24}/>
                <Skeleton height={24}/>
            </ListContainer>
        </SkeletonTheme>
    );
};
